import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import logoPayvalis from '../../assets/img/logo_payvalis.png'


const CodeQRCode = ({ value, size }) => {
    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <QRCodeSVG value={value} size={size} level="H" />
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#000',
                background: 'white',
                padding: '2px 4px',
                borderRadius: '4px'
            }}>
                <img
                    src={logoPayvalis}
                    alt="PAYVALIS"
                    style={{height: "auto", width: size/2}}
                />
            </div>
        </div>
    );
};

export default CodeQRCode;
